import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {MsalProvider} from '@azure/msal-react'
import {PublicClientApplication} from '@azure/msal-browser'
import authConfig from './modules/auth/azure/authConfig'
type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  const msalInstance = new PublicClientApplication(authConfig.msal)

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <MsalProvider instance={msalInstance}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Routes />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </MsalProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
